import type { ProductTerm } from '@sravni/react-ugc/lib/ProductTerms';
import { EDUCATION_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';
import type { Tab, VITRINS_OFFERS_TYPE } from '@sravni/ugc/lib/specialOffers/types';

import { OFFERS_TABS_WITHOUT_SUBPRODUCTS_INFO } from '../constants/offersTabsInfo';
import { learningTypeInfo } from '../constants/offersTabsInfo/education';

export interface OfferTab {
  key: Tab<VITRINS_OFFERS_TYPE>;
  label: string;
  generalLink: string;
  generalLinkLabel: string;
  linkToOneProduct?: string;
  getConditions?: (offer) => ProductTerm[];
  advertisingCategory: string;

  buttonAction?: string;
  getVerticalWidgetConditions?: (offer) => ProductTerm[];
}

export const getTabsInfo = ({ type, subtype }: Tab): OfferTab => {
  if (type === EDUCATION_OFFERS.learning && subtype) {
    return learningTypeInfo[subtype];
  }
  return OFFERS_TABS_WITHOUT_SUBPRODUCTS_INFO[type];
};
